import { createSelector } from '@reduxjs/toolkit';
import warning from 'fbjs/lib/warning';

const getAll = (state) => state.view.zones;
const zoneSelector = createSelector(
  [getAll, (_state, zoneId) => zoneId],
  (zones, zoneId) => {
    let zone = zones.find(({ zone_id }) => zone_id === zoneId);
    if (zone) {
      return zone;
    }
    /*
		 при адаптации СТВ выяснилось что они используют свои именования зон,
		 этот "костыль" нужен как раз на этот случай,
		 будет работать пока у нас есть только одна зона
		*/
    zone = zones[0];
    if (zone) {
      warning(
        zones.length === 1,
        'Rely on only one zone does not work any more, fix it.',
      );
      return zone;
    }
  },
);

const zoneSlice = {
  getAll,
  getZoneById(state, zoneId) {
    return getAll(state).find((zone) => zone.zone_id === zoneId);
  },
  zoneSelector,
};
export default zoneSlice;
